import { useQuery } from 'react-query';
import { useOkapiKy, useNamespace } from '@folio/stripes/core';

const SOURCE_FILES_API = 'authority-source-files';

export const useAuthoritySourceFiles = ({ tenantId } = {}) => {
  const ky = useOkapiKy({ tenant: tenantId });
  const [namespace] = useNamespace({ key: 'authority-source-files' });

  const { isFetching, data, error } = useQuery(
    [namespace, tenantId],
    async () => {
      return ky.get(`${SOURCE_FILES_API}?limit=50`).json();
    },
    {
      // Cache for 5 minutes since source files don't change often
      staleTime: 5 * 60 * 1000,
      cacheTime: 10 * 60 * 1000,
    }
  );

  const getSourceFileNameById = (id) => {
    // Handle null, undefined, empty string, or "NULL" string
    if (!id || id === 'NULL' || id === 'null' || !data?.authoritySourceFiles) {
      return null;
    }

    const sourceFile = data.authoritySourceFiles.find(file => file.id === id);
    return sourceFile?.name || null;
  };

  return {
    sourceFiles: data?.authoritySourceFiles || [],
    getSourceFileNameById,
    isLoading: isFetching,
  };
};
